module.exports = __webpack_public_path__ + "static/media/6 21 '03_7bbc7744-7c17-40f8-b827-db4132d37130.17488989.png";